import { render, staticRenderFns } from "./CodingRequestPro.vue?vue&type=template&id=fa80788c&scoped=true&"
import script from "./CodingRequestPro.vue?vue&type=script&lang=js&"
export * from "./CodingRequestPro.vue?vue&type=script&lang=js&"
import style0 from "./CodingRequestPro.vue?vue&type=style&index=0&id=fa80788c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa80788c",
  null
  
)

export default component.exports